import React  from "react";
import BlogStep from "./components/BlogStep/BlogStep";
//    <link rel="stylesheet" to="./plugins/nice-select/nice-select.css" />
import { AnimationFileLoader } from '../../../utilis/animation-loader'; // Adjust the path
import {NavLink } from "react-router-dom";

function HelpCenter() {
    AnimationFileLoader();

    return (
      <>
  
      {/* Author */}
    <div className="author-area">
        <div className="author-cover" data-bg-img="/img/bg/author-cover.png"></div>
    </div>
    {/* End Author */}

    {/* Create Collectible */}
    <section className="pt-120 pb-120">
        <div className="container">
            <div className="row justify-content-center">
                <div className="col-lg-8">
                    {/* Section Title */}
                    <div className="section-title text-center text-white">
                        <h2>Help Center</h2>
                    </div>
                    {/* End Section Title */}
                </div>
            </div>

            <div className="row">
                <div className="col-12">
                    <form className="search-form style--three" action="#" method="get">
                        <div className="form-group">
                            <input type="search" className="form-control mb-0" placeholder="I have NavLink question about..."
                                required />
                            <button type="submit"><img src="/img/icons/btn-help.svg" alt="" className="svg"/> Get
                                Help</button>
                        </div>
                    </form>
                </div>
            </div>

            <div className="row mt-60">
                <div className="col-12">
                    <ul className="nav faqs-tab-buttons mb-30">
                        <li className="nav-item">
                            <button className="active" data-bs-toggle="tab" data-bs-target="#getting-started">Getting
                                Started</button>
                        </li>
                        <li className="nav-item" role="presentation">
                            <button data-bs-toggle="tab" data-bs-target="#create-sell">Create & Sell</button>
                        </li>
                        <li className="nav-item" role="presentation">
                            <button data-bs-toggle="tab" data-bs-target="#faqs">FAQs</button>
                        </li>
                        <li className="nav-item" role="presentation">
                            <button data-bs-toggle="tab" data-bs-target="#connect-wallet">Connect Wallet</button>
                        </li>
                    </ul>
                    <div className="tab-content">
                        <div className="tab-pane fade show active" id="getting-started">
                            <div className="tab-links getting-started-links">


                                <BlogStep to="blog-details.html" iconImgSrc="/img/icons/tab-icon.svg" content="Step 1: Set up an Ethereum Wallet."/>

                                <BlogStep to="blog-details.html" iconImgSrc="/img/icons/tab-icon.svg" content="Step 2: Purchase NavLink small amount of Ethereum"/>

                                <BlogStep to="blog-details.html" iconImgSrc="/img/icons/tab-icon.svg" content="Step 3: Connect your wallet to an NFT Marketplace"/>

                                <BlogStep to="blog-details.html" iconImgSrc="/img/icons/tab-icon.svg" content="Step 4: Make NavLink Digital Art File for your NFT"/>

                                <BlogStep to="blog-details.html" iconImgSrc="/img/icons/tab-icon.svg" content="Step 5: Price your Art and List it on NavLink Marketplace"/>


                            </div>
                        </div>
                        <div className="tab-pane fade" id="create-sell">
                            <div className="tab-links getting-started-links">
                                <NavLink to="blog-details.html">
                                    <img src="/img/icons/tab-icon.svg" alt="" className="svg"/>
                                    Pick your item.
                                    <img src="/img/icons/tab-arrow.svg" alt="" className="svg tab-arrow"/>
                                </NavLink>
                                <NavLink to="blog-details.html">
                                    <img src="/img/icons/tab-icon.svg" alt="" className="svg"/>How to Get in to
                                    Choose your blockchain.<img src="/img/icons/tab-arrow.svg" alt=""
                                        className="svg tab-arrow"/></NavLink>
                                <NavLink to="blog-details.html">
                                    <img src="/img/icons/tab-icon.svg" alt="" className="svg"/>Set up your digital
                                    wallet.<img src="/img/icons/tab-arrow.svg" alt="" className="svg tab-arrow"/></NavLink>
                                <NavLink to="blog-details.html">
                                    <img src="/img/icons/tab-icon.svg" alt="" className="svg"/>Select your NFT
                                    marketplace.<img src="/img/icons/tab-arrow.svg" alt=""
                                        className="svg tab-arrow"/></NavLink>
                                <NavLink to="blog-details.html">
                                    <img src="/img/icons/tab-icon.svg" alt="" className="svg"/>Upload your file.<img
                                        src="/img/icons/tab-arrow.svg" alt="" className="svg tab-arrow"/></NavLink>
                            </div>
                        </div>
                        <div className="tab-pane fade" id="faqs">
                            <div className="accordion">
                                <div className="accordion-item">
                                    <h2 className="accordion-header" id="headingOne">
                                        <button className="accordion-button" type="button" data-bs-toggle="collapse"
                                            data-bs-target="#collapseOne" aria-expanded="true"
                                            aria-controls="collapseOne">
                                            How do NFTs work?
                                        </button>
                                    </h2>
                                    <div id="collapseOne" className="accordion-collapse collapse show"
                                        aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                                        <div className="accordion-body">
                                            At NavLink very high level, most NFTs are part of the Ethereum blockchain.
                                            Ethereum is NavLink cryptocurrency, like bitcoin or dogecoin, but its blockchain
                                            also supports these NFTs, which store extra information that makes them work
                                            differently from, say, an ETH coin. It is worth noting that other
                                            blockchains can implement their own versions of NFTs.
                                        </div>
                                    </div>
                                </div>
                                <div className="accordion-item">
                                    <h2 className="accordion-header" id="headingTwo">
                                        <button className="accordion-button collapsed" type="button"
                                            data-bs-toggle="collapse" data-bs-target="#collapseTwo"
                                            aria-expanded="false" aria-controls="collapseTwo">
                                            What’s worth picking up at the NFT supermarket?
                                        </button>
                                    </h2>
                                    <div id="collapseTwo" className="accordion-collapse collapse"
                                        aria-labelledby="headingTwo" data-bs-parent="#accordionExample">
                                        <div className="accordion-body">
                                            At NavLink very high level, most NFTs are part of the Ethereum blockchain.
                                            Ethereum is NavLink cryptocurrency, like bitcoin or dogecoin, but its blockchain
                                            also supports these NFTs, which store extra information that makes them work
                                            differently from, say, an ETH coin. It is worth noting that other
                                            blockchains can implement their own versions of NFTs.
                                        </div>
                                    </div>
                                </div>
                                <div className="accordion-item">
                                    <h2 className="accordion-header" id="headingThree">
                                        <button className="accordion-button collapsed" type="button"
                                            data-bs-toggle="collapse" data-bs-target="#collapseThree"
                                            aria-expanded="false" aria-controls="collapseThree">
                                            You mean, like, people buying my good tweets?
                                        </button>
                                    </h2>
                                    <div id="collapseThree" className="accordion-collapse collapse"
                                        aria-labelledby="headingThree" data-bs-parent="#accordionExample">
                                        <div className="accordion-body">
                                            At NavLink very high level, most NFTs are part of the Ethereum blockchain.
                                            Ethereum is NavLink cryptocurrency, like bitcoin or dogecoin, but its blockchain
                                            also supports these NFTs, which store extra information that makes them work
                                            differently from, say, an ETH coin. It is worth noting that other
                                            blockchains can implement their own versions of NFTs.
                                        </div>
                                    </div>
                                </div>
                                <div className="accordion-item">
                                    <h2 className="accordion-header" id="headingFour">
                                        <button className="accordion-button collapsed" type="button"
                                            data-bs-toggle="collapse" data-bs-target="#collapseFour"
                                            aria-expanded="false" aria-controls="collapseFour">
                                            Do people really think this will become like art collecting?
                                        </button>
                                    </h2>
                                    <div id="collapseFour" className="accordion-collapse collapse"
                                        aria-labelledby="headingFour" data-bs-parent="#accordionExample">
                                        <div className="accordion-body">
                                            At NavLink very high level, most NFTs are part of the Ethereum blockchain.
                                            Ethereum is NavLink cryptocurrency, like bitcoin or dogecoin, but its blockchain
                                            also supports these NFTs, which store extra information that makes them work
                                            differently from, say, an ETH coin. It is worth noting that other
                                            blockchains can implement their own versions of NFTs.
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="tab-pane fade" id="connect-wallet">
                            <div className="tab-links getting-started-links">
                                <NavLink to="blog-details.html">
                                    <img src="/img/icons/tab-icon.svg" alt="" className="svg"/>
                                    What Exactly Are
                                    NFTs?
                                    <img src="/img/icons/tab-arrow.svg" alt="" className="svg tab-arrow"/>
                                </NavLink>
                                <NavLink to="blog-details.html">
                                    <img src="/img/icons/tab-icon.svg" alt="" className="svg"/>How to Get in to
                                    NFT Business and earn Money?<img src="/img/icons/tab-arrow.svg" alt=""
                                        className="svg tab-arrow"/></NavLink>
                                <NavLink to="blog-details.html">
                                    <img src="/img/icons/tab-icon.svg" alt="" className="svg"/>What are Best
                                    Platforms for Creators to Get Featured?<img src="/img/icons/tab-arrow.svg"
                                        alt="" className="svg tab-arrow"/></NavLink>
                                <NavLink to="blog-details.html">
                                    <img src="/img/icons/tab-icon.svg" alt="" className="svg"/>How it is That
                                    NFTs are Under Rated?<img src="/img/icons/tab-arrow.svg" alt=""
                                        className="svg tab-arrow"/></NavLink>
                                <NavLink to="blog-details.html">
                                    <img src="/img/icons/tab-icon.svg" alt="" className="svg"/>How Many
                                    Artworks & Creators are There in Anefty?<img src="/img/icons/tab-arrow.svg"
                                        alt="" className="svg tab-arrow"/></NavLink>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="row mt-60">
                <div className="col-12">
                    {/* Help Center Contact */}
                    <div className="hc-contact media">
                        <div className="img">
                            <img src="/img/media/contact.png" alt=""/>
                        </div>
                        <div className="content media-body">
                            <h2>Unable to Find Your Answer?</h2>
                            <p>Anefty are non-fungible tokens. they are uniques items that you can't replace with
                                something else. for example, NavLink one-of-NavLink-kind trading card is an NFT – you can't just
                                replace it with any other card. If you trade your card for some other card.</p>
                            <NavLink to="contact.html" className="btn"><img src="/img/icons/btn-contact.svg" alt=""
                                    className="svg"/> contact</NavLink>
                        </div>
                    </div>
                    {/* End Help Center Contact */}
                </div>
            </div>
        </div>
    </section>
    {/* End Create Collectible */}
 
    </>
  );
}

export default HelpCenter;
